import * as React from "react"

import { Badge } from "@/components/ui/badge"
import { cn } from "@/lib/utils"
import { toneDotClass, type StatusTone } from "@/lib/status-colors"

/**
 * A domain status, rendered as a neutral pill with a coloured mark.
 *
 * The label carries the meaning and stays on `--foreground`; the dot carries the
 * tone. That split is what lets the badge use saturated status hues while still
 * clearing 4.5:1 — tinting the text with the tone itself does not, in light mode.
 */
function StatusBadge({
  tone,
  label,
  className,
  ...props
}: Omit<React.ComponentPropsWithoutRef<"span">, "children"> & {
  tone: StatusTone
  label: string
}) {
  return (
    <Badge
      variant="outline"
      data-slot="status-badge"
      data-tone={tone}
      className={cn("gap-1.5 font-medium", className)}
      {...props}
    >
      <span data-slot="status-badge-dot" aria-hidden="true" className={toneDotClass(tone)} />
      {label}
    </Badge>
  )
}

export { StatusBadge }
